module.exports = __webpack_public_path__ + "static/media/my-vinos-actions.fe642a14.png";